import { PermissionUtil } from "src/framework/commons/PermissionUtil"

export const validacaoValorServicoMinimo = (valorServico: number, valorMinimo: number, permissions: string[]) => {
  if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissions)) return true;
  if (valorServico === 0) return true;
  if (valorMinimo === 0) return true;
  return valorServico >= valorMinimo;
}